import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Logout, Person } from '@mui/icons-material';
import {
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover
} from '@mui/material';

import { RoutePath } from '@/routes/RoutePath';

interface CurrentUserPopoverProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  anchorEl: HTMLDivElement;
  handleNavigate?: VoidFunction;
}

export const CurrentUserPopover: React.FC<CurrentUserPopoverProps> = ({
  isOpen,
  setIsOpen,
  anchorEl,
  handleNavigate
}) => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  const navigateToProfile = () => {
    navigate(RoutePath.Profile);
    setIsOpen(false);
    handleNavigate?.();
  };

  return (
    <>
      <Popover
        PaperProps={{
          sx: {
            width: 245,
            boxShadow: '0px 5px 20px 2px rgba(44, 58, 66, 0.15)',
            borderRadius: '8px'
          }
        }}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <List>
          <ListItemButton onClick={navigateToProfile}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText>Profile settings</ListItemText>
          </ListItemButton>
          <Divider />
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </ListItemButton>
        </List>
      </Popover>
    </>
  );
};
